<template>
  <div
    :class="
      $style['promotion']
    "
    @click="onClick">
    <div
      :class="$style['promotion__background']" />
    <div
      :class=" $style['promotion__glasses-one']" />
    <div
      :class="$style['promotion__glasses-two']" />
    <div
      :class="$style['promotion__glasses-three']" />
    <div :class="$style['promotion__inner']">
      <Btn
        v-if="(promotionData.link && promotionData.showLink) && shouldShow(promotionData.link)"
        aria-label="Go to promotion"
        icon-only="System/arrow-right-s-line"
        color="cta"
        shape="round" />
    </div>
  </div>
</template>
<script>
import baseScript from './Shared/script'
export default {
  extends: baseScript
}
</script>
<style lang="scss" module>
@use './Shared/style';

.promotion {
  position: relative;

  &__background {
    position: absolute;
    width: 100%;
    aspect-ratio: 16 / 13;
    background-size: cover;
    background-image: url('/images/promotions/free-gift-sunglasses/background.webp');
  }

  &__glasses-three,
  &__glasses-two,
  &__glasses-one {
    position: absolute;
    width: 100%;
    aspect-ratio: 16 / 13;
    background-size: cover;
    background-image: url('/images/promotions/free-gift-sunglasses/sunglasses-1.webp');

    animation-name: switchone;
    animation-duration: 3s;
    animation-iteration-count: infinite;
  }

  &__glasses-two {
    animation-name: switchtwo;
    animation-duration: 3s;
    animation-iteration-count: infinite;
    background-image: url('/images/promotions/free-gift-sunglasses/sunglasses-2.webp');
  }

  &__glasses-three {
    animation-name: switchthree;
    animation-duration: 3s;
    animation-iteration-count: infinite;
    background-image: url('/images/promotions/free-gift-sunglasses/sunglasses-3.webp');
  }

}

@keyframes switchone {
  0% {
    opacity: 1;
  }

  33.33% {
    opacity: 1;
  }

  33.34% {
    opacity: 0;
  }

  66.66% {
    opacity: 0;
  }

  66.67% {
    opacity: 0;
  }

  100% {
    opacity: 0;
  }
}

@keyframes switchtwo {
  0% {
    opacity: 0;
  }

  33.33% {
    opacity: 0;
  }

  33.34% {
    opacity: 1;
  }

  66.66% {
    opacity: 1;
  }

  66.67% {
    opacity: 0;
  }

  100% {
    opacity: 0;
  }
}

@keyframes switchthree {
  0% {
    opacity: 0;
  }

  33.33% {
    opacity: 0;
  }

  33.34% {
    opacity: 0;
  }

  66.66% {
    opacity: 0;
  }

  66.67% {
    opacity: 1;
  }

  100% {
    opacity: 1;
  }
}

</style>
